import { render, staticRenderFns } from "./SimpleDateView.vue?vue&type=template&id=61f0874e&"
import script from "./SimpleDateView.vue?vue&type=script&lang=js&"
export * from "./SimpleDateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports